import * as Yup from 'yup'


/** Pickup Consignment Inbound Request Receiving schema for Exclusive Seller (no maximum quantity) */
const consignmentInboundRequestReceivePickupForExclusiveSellerSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .required('Required'),
  received_weight        : Yup.number().positive('Must be more than 0').required('Required'),
  pickup_tracking_number : Yup.string().required('Required')
})

export default consignmentInboundRequestReceivePickupForExclusiveSellerSchema
